<template>
   <div class="coupon" v-loading.fullscreen.lock="loading">
        <headerTab :tabList="tabList" @tabChange="tabChange"></headerTab>
        <div  v-if="total > 0">
            <div class="coupon_box" v-if="couponList.length > 0">
                <div v-for="item in couponList" :key="item.id">
                    <div class="coupon_box_items" v-if="item.is_use == 0">
                        <div class="coupon_box_item">
                            <div class="coupon_box_item_left">
                                <img class="coupon_box_item_left_img" src="../../assets/coupon/coupon_type1.png" alt="">
                                <div class="coupon_box_item_left_money">
                                    <span class="coupon_box_item_left_money_unit">￥</span>
                                    <span class="coupon_box_item_left_money_num">{{item.reduce}}</span>
                                </div>
                                <div class="coupon_box_item_left_msg">
                                    满{{item.full}}元可用
                                </div>
                            </div>
                            <div class="coupon_box_item_line"></div>
                            <div class="coupon_box_item_right">
                                <p class="coupon_box_item_right_title">{{item.card_name}}</p>
                                <p class="coupon_box_item_right_time">使用时间：{{item.start_time}}-{{item.end_time}}</p>
                                <div class="coupon_box_item_right_msg">
                                    <div>使用说明</div>
                                    <img @click="selectId = item.id" v-if="selectId != item.id" src="../../assets/coupon/coupon_icon_down.png" alt="">
                                    <img @click="selectId = ''" v-if="selectId == item.id" src="../../assets/coupon/coupon_icon_up.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="coupon_box_msg" v-if="selectId == item.id">
                            <p>1.{{item.instructions}}</p>
                            <p>2.满{{item.reduce}}元可用</p>
                        </div>
                    </div>
                    <div class="coupon_box_no_items" v-if="item.is_use == 1">
                        <div class="coupon_box_no_item">
                            <div class="coupon_box_no_item_left">
                                <img class="coupon_box_no_item_left_img" src="../../assets/coupon/coupon_no_type1.png" alt="">
                                <div class="coupon_box_no_item_left_money">
                                    <span class="coupon_box_no_item_left_money_unit">￥</span>
                                    <span class="coupon_box_no_item_left_money_num">{{item.reduce}}</span>
                                </div>
                                <div class="coupon_box_no_item_left_msg">
                                    满{{item.full}}元可用
                                </div>
                            </div>
                            <div class="coupon_box_no_item_line"></div>
                            <div class="coupon_box_no_item_right">
                                <p class="coupon_box_no_item_right_title">{{item.card_name}}</p>
                                <p class="coupon_box_no_item_right_time">使用时间：{{item.start_time}}-{{item.end_time}}</p>
                                <div class="coupon_box_no_item_right_msg">
                                    <div>使用说明</div>
                                    <img @click="selectId = item.id" v-if="selectId != item.id" src="../../assets/coupon/coupon_icon_down.png" alt="">
                                    <img @click="selectId = ''" v-if="selectId == item.id" src="../../assets/coupon/coupon_icon_up.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="coupon_box_no_msg" v-if="selectId == item.id">
                            <p>1.{{item.instructions}}</p>
                            <p>2.满{{item.reduce}}元可用</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="coupon_pagination" v-if="total != 0">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :pager-count="9"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>
                <div class="coupon_pagination_right">
                    <div class="coupon_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                    <div class="coupon_pagination_right_input">
                        到第
                        <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                        页
                    </div>
                    <div class="coupon_pagination_right_btn">
                        <el-button size="small" @click="changeNumberInput">确定</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="null" v-if="total == 0">
            <img src="../../assets/null.png" style="width:376px;height:277px" class="null_img" alt="">
            <div class="null_title">暂无优惠券</div>
        </div>
        
       
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
export default {
   data (){
       return {
           tabList:[
               {name:'全部',id:-1},
               {name:'可使用',id:0},
               {name:'已使用',id:1}
           ],
           tabId:-1,
           show1:false,
           show:false,
           loading:false,
           couponList:[],
           selectId:'',
           pageNumber:1,
           pageNumberInput:1,
           lastPage:0,
           total:0,
           pageSize:10,

       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       tabChange(id){
           this.tabId = id;
           this.total = 0;
           this.pageNumber = 1;
           this.pageNumberInput = 1;
           this.getCouponList();
       },
    //    获取列表
       getCouponList(){
           this.loading = true;
           this.couponList = [];
           let params = {
               page_index:this.pageNumber,
               page_size:this.pageSize,
               type:this.tabId
           }
           this.$get('coupon',params)
                .then(data => {
                    this.loading = false;
                    this.couponList = data.data;
                    this.total = data.total;
                    this.lastPage = data.last_page;
                } , error => {
                    this.loading = false;
                    this.$message.error(error);
                });
       },
    //    切换页码
       handleCurrentChange(val){
           this.pageNumber = val;
            this.pageNumberInput = val;
            this.getCouponList();
       },
        // 手动输入页码后确定
       changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return 
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getCouponList();
       }
   },
   created() {
       
   },
   mounted() {
       this.getCouponList();
   }
}
</script>

<style scoped lang='less'>
.coupon{
    &_pagination{
        padding-top:30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#000000;
        /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
            min-width: 36px;
            height: 36px;
            padding-top:4px;
            margin: 0 4px;
        }
        /deep/ .btn-prev{
            margin-left: 0;
        }
        &_right{
            display: flex;
            align-items: baseline;
            &_num{
                span{
                    color:#3D7FFF;
                }
                
            }
            &_input{
                margin:0 10px;
            }
            &_btn{
                /deep/ .el-button{
                    background:#F0F2F5;
                    height: 36px;
                    border:1px solid #D7DBE0;
                    font-size: 14px;
                    color:#333;
                }
                /deep/ .el-button:hover{
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }
                
            }
        }
    }
    &_box{
        display: flex;
        flex-wrap:wrap;
        
        &_items{
            margin-left: 20px;
        }
        &_item{
            width:360px;
            height: 100px;
            background:url('../../assets/coupon/coupon_bg1.png') no-repeat;
            background-size: 360px 100px;
            margin-top:20px;
            display: flex;
            &_left{
                position: relative;
                width:96px;
                &_img{
                    position:absolute;
                    width:44px;
                    left:0;
                    top:0;
                }
                &_money{
                    text-align: center;
                    color:#fff;
                    margin-top:30px;
                    font-weight: 800;
                    display: flex;
                    justify-content:center;
                    align-items:flex-end;
                    &_unit{
                        font-size:12px;
                    }
                    &_num{
                        font-size:20px;
                        line-height: 20px;
                    }
                }
                &_msg{
                    color:#FDB5B3;
                    font-size: 14px;
                    font-weight: 400;
                    text-align: center;
                    margin-top:10px;
                }
            }
            &_line{
                width:1px;
                height:58px;
                border-left:1px dashed #FDB5B3;
                margin-top:21px;

            }
            &_right{
                width:254px;
                margin-left:10px;
                font-size: 14px;
                line-height: 14px;;
                &_title{
                    font-weight: 500;
                    color:#fff;
                    margin:14px 0 14px 0;
                }
                &_time{
                    color:#FDB5B3;
                    margin-bottom:14px;
                }
                &_msg{
                    color:#FDB5B3;
                    display: flex;
                    justify-content:space-between;
                    align-items:center;
                    img{
                        width:10px;
                        height: 10px;
                        margin-right:37px;
                        cursor: pointer;
                    }
                }
            }
            
        }
        &_msg{
            width:360px;
            padding:16px 20px 10px 10px;
            background:#F7F9FC;
            color:#A6AEC1;
            line-height: 25px;
        }
    }
    &_box_no{
        display: flex;
        flex-wrap:wrap;
        
        &_items{
            margin-left: 20px;
        }
        &_item{
            width:360px;
            height: 100px;
            background:url('../../assets/coupon/coupon_bg2.png') no-repeat;
            background-size: 360px 100px;
            margin-top:20px;
            display: flex;
            &_left{
                position: relative;
                width:96px;
                &_img{
                    position:absolute;
                    width:44px;
                    left:0;
                    top:0;
                }
                &_money{
                    text-align: center;
                    color:#999999;
                    margin-top:30px;
                    font-weight: 800;
                    display: flex;
                    justify-content:center;
                    align-items:flex-end;
                    &_unit{
                        font-size:12px;
                    }
                    &_num{
                        font-size:20px;
                        line-height: 20px;
                    }
                }
                &_msg{
                    color:#B3B3B3;
                    font-size: 14px;
                    font-weight: 400;
                    text-align: center;
                    margin-top:10px;
                }
            }
            &_line{
                width:1px;
                height:58px;
                border-left:1px dashed #fff;
                margin-top:21px;

            }
            &_right{
                width:254px;
                margin-left:10px;
                font-size: 14px;
                line-height: 14px;;
                &_title{
                    font-weight: 500;
                    color:#999999;
                    margin:14px 0 14px 0;
                }
                &_time{
                    color:#B3B3B3;
                    margin-bottom:14px;
                }
                &_msg{
                    color:#B3B3B3;
                    display: flex;
                    justify-content:space-between;
                    align-items:center;
                    img{
                        width:10px;
                        height: 10px;
                        margin-right:37px;
                        cursor: pointer;
                    }
                }
            }
            
        }
        &_msg{
            width:360px;
            padding:16px 20px 10px 10px;
            background:#F7F9FC;
            color:#A6AEC1;
            line-height: 25px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/coupon.vue